import {
  DateFormat,
  DateFormatConfig,
  DateNumberFormat,
  DateStringFormat,
  DateValueFormat,
  TimeFormat,
  TimeFormatConfig,
} from './types';

export const IntlDateFormats: Record<DateFormat, DateFormatConfig> = {
  [DateFormat.Full]: {
    weekday: DateStringFormat.Long,
    month: DateValueFormat.Long,
    day: DateNumberFormat.Numeric,
    year: DateNumberFormat.Numeric,
  },
  [DateFormat.Short]: {
    month: DateValueFormat.Short,
    day: DateNumberFormat.Numeric,
    year: DateNumberFormat.Numeric,
  },
  [DateFormat.Numeric]: {
    month: DateValueFormat.TwoDigit,
    day: DateNumberFormat.TwoDigit,
    year: DateNumberFormat.Numeric,
  },
};

export const IntlTimeFormats: Record<TimeFormat, TimeFormatConfig> = {
  [TimeFormat.Locale]: {
    hour: DateNumberFormat.Numeric,
    minute: DateNumberFormat.TwoDigit,
  },
  [TimeFormat.TwelveHour]: {
    hour: DateNumberFormat.Numeric,
    minute: DateNumberFormat.TwoDigit,
    hour12: true,
  },
  [TimeFormat.Military]: {
    hour: DateNumberFormat.Numeric,
    minute: DateNumberFormat.TwoDigit,
    hour12: false,
  },
};
